export enum PreApprovalSteps {
    StatedIncome = 'SI',
    PurchasePrice = 'PP',
    DownPayment = 'DP',
    CreditCheck = 'CC',
    Error = 'E'
}